<template>
  <v-card><v-card-title>
    <v-form>
      <v-switch
        :label="`Are you new here?`"
        v-model="newplayer"
      ></v-switch>
      <v-text-field label="What is your name?" v-model="username" type="text" name="username" placeholder="[ write your username here ]" />
      <v-text-field @keyup.enter="newplayer ? doRegister() : doLogin()" label="Tell me a secret..." v-model="password" type="password" name="password" placeholder="[ write your password here ]" />
      <v-btn @click="newplayer ? doRegister() : doLogin()">Enter</v-btn>
    </v-form>
  </v-card-title></v-card>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      newplayer: false,
      username: '',
      password: '',
      register: false
    }
  },
  methods: {
    doRegister () {
      console.log('registering') // eslint-disable-line no-console
      this.$socket.emit('register', {
        username: this.username,
        password: this.password
      })
    },
    doLogin () {
      console.log('logging in') // eslint-disable-line no-console
      this.$socket.emit('login', {
        username: this.username,
        password: this.password
      })
    }
  }
}
</script>
